{
    "Device_Filter_SectionHeader": "Filtraggio del tipo di dispositivo",
    "Device_Filter_Dropdown_Label": "Tipo di dispositivo",
    "NAME": "ReportsFilterDeviceFilter"
}